import React, { forwardRef } from 'react'
import { Input, Icon } from '@planningcenter/tapestry-react'

const Field = forwardRef(({ value, onChange }, ref) => {
  return (
    <Input.InputBox
      mediaQueries={{
        lg: {
          marginRight: 1,
          marginBottom: 0,
        },
      }}
    >
      <Icon name="general.search" size="sm" color="grey-6" marginRight={1} />
      <Input.InputField
        value={value}
        placeholder={'Search'}
        onChange={onChange}
        ref={ref}
      />
    </Input.InputBox>
  )
})

export default Field
